// extracted by mini-css-extract-plugin
module.exports = {"container":"container--CheckoutLegalLinks-components__2uRgc","link":"link--CheckoutLegalLinks-components__1mYuc","separator":"separator--CheckoutLegalLinks-components__1DAwn"};